// Angular dependencies
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Rxjs dependencies
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

// App dependencies
import { Creep } from '../creep/creep';
import { Skill } from '../creep-skill';

// Store
import { Store, State } from '@ngrx/store';
import {
  AppState,

  AddCreepAction,
  UpdateCreepAction,
  CreepUndoAction,
  CreepActions,
  GotoMainAction,
  GotoBackAction,

  selectCreepActions,
} from '../store.module';

@Component({
  selector: 'app-page-creep-level',
  templateUrl: './page-creep-level.component.html',
  styleUrls: ['./page-creep-level.component.scss']
})
export class PageCreepLevelComponent implements OnInit, OnDestroy {
  creep: Creep;
  private subscription$: Subscription;
  public actions$: Observable<Skill[]>;
  public confirm$: BehaviorSubject<any>;

  constructor(
    private _state: State<AppState>,
    private _store: Store<AppState>,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this._store.dispatch(new CreepActions([]));
    this.confirm$ = new BehaviorSubject(false);
    this.actions$ = this._store.select(selectCreepActions);

    this.subscription$ = this._route
      .queryParams
      .map(({ edit }) => edit)
      .filter((_) => _)
      .map((edit) => Creep.fromString(edit))
      .do((creep) => {
        console.log(creep);
        this.creep = creep;
      })
      .subscribe();
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

  onSave() {
    const { creeps } = this._state.getValue().creeps;

    const match = creeps.find(({ _id }: Creep) => {
      return this.creep._id === _id;
    });

    if (match) {
      this._store.dispatch(new UpdateCreepAction([this.creep, match]));
    } else {
      this._store.dispatch(new AddCreepAction(this.creep));
    }
  }

  onUndo() {
    this._store.dispatch(new CreepUndoAction());
  }

  onBack() {
    if (window.history.length === 2) {
      this._store.dispatch(new GotoMainAction());
      return;
    }

    this._store.dispatch(new GotoBackAction());
  }

  showConfirm(callback) {
    this.actions$
      .subscribe((v) => {
        if (v.length) {
          this.confirm$.next(callback);
          return;
        }

        callback();
      })
      .unsubscribe();
  }

  hideConfirm(confirm) {
    if (confirm) {
      const callback = this.confirm$.getValue();
      callback();
    }

    this.confirm$.next(false);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/page-creep-level.component.ts